export default "__VITE_ASSET__Bc9maec3__"